import { ApiInstance } from "@/libs/api-manager";
import { IAppVersionFlag } from "@/types/appVersionFlag";

export const updateAppVersionFlag = async ({
  id,
  ...payload
}: Pick<
  IAppVersionFlag,
  "id" | "di" | "major" | "minor" | "patch" | "clientAppId"
>) => {
  const { data } = await ApiInstance.put(
    `/api/vpn/app_version_flags/${id}`,
    payload
  );

  return data;
};
